import {CollisionEventType, Component, PhysXComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import { vec3, quat } from 'gl-matrix';

/**
 * safety-reset
 */
export class SafetyReset extends Component {
    static TypeName = 'safety-reset';

    private physxComp: PhysXComponent | null = null;
    private originalPosition: vec3 = vec3.create();
    private originalRotation: quat = quat.create();
    private framesUntilDynamic: number = 0;

    start() {
        this.physxComp = this.object.getComponent('physx') as PhysXComponent;
        if (!this.physxComp) {
            throw new Error(
                "The safety-reset component requires a physx component on the same object"
            );
        }

        // Store original position and rotation
        this.object.getPositionWorld(this.originalPosition);
        this.object.getRotationWorld(this.originalRotation);

        // Register collision callback
        this.physxComp.onCollision(this.onCollision.bind(this));
    }

    onCollision(type: CollisionEventType, other: PhysXComponent) {
        if (type === CollisionEventType.Touch) {
            // Check if the collided object is named "SafetyNet"
            if (other.object.name === "SafetyNet") {
                this.resetToOriginalPosition();
            }
        }
    }

    update(dt: number) {
        if (this.framesUntilDynamic > 0) {
            this.framesUntilDynamic--;
            if (this.framesUntilDynamic === 0 && this.physxComp) {
                // Restore to dynamic state
                this.physxComp.kinematic = false;
                this.physxComp.active = true;
            }
        }
    }

    resetToOriginalPosition() {
        if (!this.physxComp) return;

        // Set to kinematic to allow position/rotation changes
        this.physxComp.kinematic = true;
        this.physxComp.active = false;

        // Reset to original position and rotation
        this.object.setPositionWorld(this.originalPosition);
        this.object.setRotationWorld(this.originalRotation);

        // Schedule to restore dynamic state after 2 frames
        this.framesUntilDynamic = 2;
    }
}
